/**
 * SidebarNavigationLogo
 */
import React from 'react';

// Assets
import img from '../../../../../../assets/logo.png';

// Styles
import './styles.scss';

interface Props {}

export default class SidebarNavigationLogo extends React.PureComponent<Props> {
    render() {
        return (
            <div className="sidebar-navigation-logo-wrapper">
                <img
                    src={img}
                    alt="OrchardHand logo"
                    className="sidebar-navigation-logo"
                />
            </div>
        );
    }
}
